<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">{{data.title}}</h4>
  <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onCancel()" title="Close"></i>
</div>
<div class="modal-body text-grey">
  <p>{{ data.message }}</p>
</div>
<div class="modal-footer text-grey">
  <button type="button" class="btn btn-outline-secondary" title="Cancel upload for current file." (click)="onSubmit(false)">Abort</button>
  <button type="button" *ngIf="showAllButtons" class="btn btn-outline-secondary" title="Cancel upload for all existing files in queue." (click)="onSubmit(1)">Abort All</button>
  <button type="button" class="btn btn-outline-primary" title="Overwrite current file." (click)="onSubmit(2)">Overwrite</button>
  <div ngbDropdown class="d-inline-block" container="body" *ngIf="showAllButtons">
    <button type="button" class="btn btn-outline-primary" id="dropdownForm1" ngbDropdownToggle>
      Overwrite All
    </button>
    <div ngbDropdownMenu aria-labelledby="dropdownForm1">
      <div class="fw-bold">Note : All files selected for upload will be overwritten if file(s) already exists.</div>
      <button type="button" class="btn btn-outline-primary mt-3" (click)="onSubmit(3)">Confirm</button>
    </div>
  </div>
</div>